module.exports = __webpack_public_path__ + "static/media/accessibilitykeysonkeyboard.41fb4a10.jpg";